import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4b7b8473"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Shelf Width", -1))
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Shelf Height", -1))
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Shelf Quantity", -1))
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Clearance", -1))
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<label class=\"d-block text-black fw-semibold mb-10\" data-v-4b7b8473>Containers</label><div class=\"d-flex mb-2 fw-bold\" data-v-4b7b8473><span class=\"me-10\" style=\"flex:1;\" data-v-4b7b8473>Width</span><span class=\"me-10\" style=\"flex:1;\" data-v-4b7b8473>Height</span><span class=\"me-10\" style=\"flex:1;\" data-v-4b7b8473>Proportion (%)</span></div>", 2)
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
    type: "submit"
  }, " Submit ")
], -1))
const _hoisted_25 = {
  key: 0,
  class: "mt-25"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-black fw-semibold mb-10" }, "Summary Table", -1))
const _hoisted_27 = { class: "table" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Container Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Width (mm)"),
    /*#__PURE__*/_createElementVNode("th", null, "Height (mm)"),
    /*#__PURE__*/_createElementVNode("th", null, "Total Quantity"),
    /*#__PURE__*/_createElementVNode("th", null, "Target Proportion"),
    /*#__PURE__*/_createElementVNode("th", null, "Achieved Proportion")
  ])
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Total Containers")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_32 = {
  key: 1,
  class: "mt-25"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-black fw-semibold mb-10" }, "Shelf Visualization", -1))
const _hoisted_34 = ["id"]
const _hoisted_35 = { class: "text-black fw-medium mb-5" }
const _hoisted_36 = { class: "shelf-visualization" }
const _hoisted_37 = { class: "level-label" }
const _hoisted_38 = { class: "level-visualization" }
const _hoisted_39 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.shelfWidth) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.shelfWidth,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.shelfHeight) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.shelfHeight,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.shelfQuantity) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.shelfQuantity,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.clearance) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.clearance,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.containers, (container, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "d-flex mb-10"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": ($event: any) => ((container.width) = $event),
                    placeholder: "Width",
                    class: "form-control mr-10",
                    style: {"flex":"1"}
                  }, null, 8, _hoisted_20), [
                    [
                      _vModelText,
                      container.width,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": ($event: any) => ((container.height) = $event),
                    placeholder: "Height",
                    class: "form-control mr-10",
                    style: {"flex":"1"}
                  }, null, 8, _hoisted_21), [
                    [
                      _vModelText,
                      container.height,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    step: "0.01",
                    "onUpdate:modelValue": ($event: any) => ((container.proportion) = $event),
                    placeholder: "Proportion",
                    class: "form-control mr-10",
                    style: {"flex":"1"}
                  }, null, 8, _hoisted_22), [
                    [
                      _vModelText,
                      container.proportion,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.removeContainer(index)),
                    type: "button",
                    class: "btn btn-danger"
                  }, " Remove ", 8, _hoisted_23)
                ]))
              }), 128)),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addContainer && _ctx.addContainer(...args))),
                type: "button",
                class: "btn btn-primary mt-10"
              }, " Add Container ")
            ])
          ]),
          _hoisted_24
        ])
      ], 32),
      (_ctx.visualizationData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("table", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedContainerSummary, (summary, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, "Container " + _toDisplayString(summary.containerId), 1),
                    _createElementVNode("td", null, _toDisplayString(summary.width), 1),
                    _createElementVNode("td", null, _toDisplayString(summary.height), 1),
                    _createElementVNode("td", null, _toDisplayString(summary.total), 1),
                    _createElementVNode("td", null, _toDisplayString((summary.targetProportion * 100).toFixed(2)) + "%", 1),
                    _createElementVNode("td", null, _toDisplayString((summary.achievedProportion * 100).toFixed(2)) + "%", 1)
                  ]))
                }), 128)),
                _createElementVNode("tr", null, [
                  _hoisted_29,
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.totalContainers), 1)
                  ]),
                  _hoisted_30,
                  _hoisted_31
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.visualizationData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _hoisted_33,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visualizationData.shelves, (shelf, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "shelf-container position-relative"
              }, [
                _createElementVNode("div", {
                  id: 'shelf-visualization-' + index
                }, [
                  _createElementVNode("h6", _hoisted_35, " Shelf " + _toDisplayString(shelf.shelf) + " (" + _toDisplayString(shelf.levels.reduce((sum, level) => sum + level.containers.length, 0)) + " Containers) ", 1),
                  _createElementVNode("div", _hoisted_36, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shelf.levels.slice().reverse(), (level, levelIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: levelIndex,
                        class: "level-container"
                      }, [
                        _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.getLevelHeight(shelf.levels, shelf.levels.length - levelIndex - 1)) + " mm ", 1),
                        _createElementVNode("div", _hoisted_38, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(level.containers, (container, containerIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: containerIndex,
                              style: _normalizeStyle(_ctx.getContainerStyle(container)),
                              class: "container-box"
                            }, " ID: " + _toDisplayString(container.containerId), 5))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ])
                ], 8, _hoisted_34),
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.exportShelfAsImage(index)),
                  class: "btn btn-primary btn-sm position-absolute",
                  style: {"top":"-10px","right":"-10px"}
                }, " Export as JPG ", 8, _hoisted_39)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}